module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item has-arrow has-droprdown"
  }, [_c('router-link', {
    class: _vm.activeMenu,
    attrs: {
      "to": {
        name: 'Tasks'
      }
    }
  }, [_c('md-icon', {
    staticClass: "arrow-icon-right",
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$root.toggleMenu($event)
      }
    }
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('md-icon', {
    staticClass: "arrow-icon-down",
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$root.toggleMenu($event)
      }
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('md-icon', [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('span', [_vm._v("Задачи")])], 1), _vm._v(" "), (_vm.projects.length) ? _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_vm._l((_vm.projects), function(project) {
    return _c('li', {
      key: ("tasks-menu-project-" + (project.id)),
      staticClass: "main-menu__item has-arrow has-droprdown"
    }, [_c('a', {
      staticClass: "action-link"
    }, [(project.tasks_status && project.tasks_status.length) ? _c('md-icon', {
      staticClass: "arrow-icon-right",
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.$root.toggleMenu($event)
        }
      }
    }, [_vm._v("keyboard_arrow_right")]) : _vm._e(), _vm._v(" "), (project.tasks_status && project.tasks_status.length) ? _c('md-icon', {
      staticClass: "arrow-icon-down",
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.$root.toggleMenu($event)
        }
      }
    }, [_vm._v("keyboard_arrow_down")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('md-menu', {
      attrs: {
        "md-size": "medium"
      }
    }, [_c('md-button', {
      staticClass: "small md-icon-button md-dense",
      attrs: {
        "md-menu-trigger": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }, [_c('md-icon', [_vm._v("more_horiz")]), _vm._v(" "), _c('md-menu-content', {
      attrs: {
        "md-theme": "white"
      }
    }, [_c('md-menu-item', {
      on: {
        "click": function($event) {
          _vm.openProjectEditDialog(project)
        }
      }
    }, [_c('span', [_vm._v("Изменить")])]), _vm._v(" "), _c('md-menu-item', {
      on: {
        "click": function($event) {
          _vm.openProjectDeleteDialog(project)
        }
      }
    }, [_c('span', [_vm._v("Удалить")])]), _vm._v(" "), _c('md-menu-item', {
      on: {
        "click": function($event) {
          _vm.openStatusAddDialog(project)
        }
      }
    }, [_c('span', [_vm._v("Добавить статус")])])], 1)], 1)], 1)], 1), _vm._v(" "), (project.tasks_status && project.tasks_status.length) ? _c('ul', {
      staticClass: "main-menu__submenu can-scroll"
    }, [_c('md-divider'), _vm._v(" "), _vm._l((project.tasks_status), function(status) {
      return _c('li', {
        staticClass: "main-menu__item"
      }, [_c('a', {
        staticClass: "action-link"
      }, [_c('span', [_vm._v(_vm._s(status.name))]), _vm._v(" "), _c('md-menu', {
        attrs: {
          "md-size": "medium"
        }
      }, [_c('md-button', {
        staticClass: "small md-icon-button md-dense",
        attrs: {
          "md-menu-trigger": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
          }
        }
      }, [_c('md-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('md-menu-content', {
        attrs: {
          "md-theme": "white"
        }
      }, [_c('md-menu-item', {
        on: {
          "click": function($event) {
            _vm.openStatusEditDialog(status)
          }
        }
      }, [_c('span', [_vm._v("Изменить")])]), _vm._v(" "), _c('md-menu-item', {
        on: {
          "click": function($event) {
            _vm.openStatusDeleteDialog(status)
          }
        }
      }, [_c('span', [_vm._v("Удалить")])])], 1)], 1)], 1)])
    }), _vm._v(" "), _c('md-divider')], 2) : _vm._e()])
  }), _vm._v(" "), _c('md-divider')], 2) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item has-arrow has-droprdown"
  }, [_c('a', {
    staticClass: "action-link"
  }, [_c('md-icon', {
    staticClass: "arrow-icon-right",
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$root.toggleMenu($event)
      }
    }
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('md-icon', {
    staticClass: "arrow-icon-down",
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$root.toggleMenu($event)
      }
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('span', [_vm._v("Теги")])], 1), _vm._v(" "), (_vm.groups && _vm.groups.length) ? _c('ul', {
    staticClass: "main-menu__submenu can-scroll"
  }, _vm._l((_vm.groups), function(group) {
    return _c('li', {
      key: ("tasks-menu-group-" + (group.id)),
      staticClass: "main-menu__item"
    }, [_c('a', {
      staticClass: "action-link"
    }, [_c('span', [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('md-menu', {
      attrs: {
        "md-size": "medium"
      }
    }, [_c('md-button', {
      staticClass: "small md-icon-button md-dense",
      attrs: {
        "md-menu-trigger": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }, [_c('md-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('md-menu-content', {
      attrs: {
        "md-theme": "white"
      }
    }, [_c('md-menu-item', {
      on: {
        "click": function($event) {
          _vm.openGroupEditDialog(group)
        }
      }
    }, [_c('span', [_vm._v("Изменить")])]), _vm._v(" "), _c('md-menu-item', {
      on: {
        "click": function($event) {
          _vm.openGroupDeleteDialog(group)
        }
      }
    }, [_c('span', [_vm._v("Удалить")])])], 1)], 1)], 1)])
  })) : _vm._e()])]), _vm._v(" "), _c('md-divider')], 1), _vm._v(" "), _c('div', {
    staticClass: "main-menu__tasks__modals"
  }, [_c('ZDialog', {
    attrs: {
      "active": _vm.editProjectDialog
    },
    on: {
      "update:active": function($event) {
        _vm.editProjectDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.editProject.id ? 'Изменить' : 'Создать') + " проект")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('ZInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 3,
        max: 255
      }),
      expression: "{required: true, min: 3, max: 255}"
    }],
    attrs: {
      "label": "Название",
      "name": "project-name",
      "data-vv-as": " ",
      "data-vv-name": "project-name",
      "data-vv-scope": "project",
      "error": _vm.errors.first('project.project-name')
    },
    model: {
      value: (_vm.editProject.name),
      callback: function($$v) {
        _vm.$set(_vm.editProject, "name", $$v)
      },
      expression: "editProject.name"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('ZButton', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.closeProjectDialog
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('ZButton', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.saveProject
    }
  }, [_vm._v("Сохранить")])], 1)], 2), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.editProjectStatusDialog
    },
    on: {
      "update:active": function($event) {
        _vm.editProjectStatusDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.editStatus.id ? 'Изменить' : 'Создать') + " статус")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('ZInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 3,
        max: 255
      }),
      expression: "{required: true, min: 3, max: 255}"
    }],
    attrs: {
      "label": "Название",
      "name": "status-name",
      "data-vv-as": " ",
      "data-vv-name": "status-name",
      "data-vv-scope": "status",
      "error": _vm.errors.first('status.status-name')
    },
    model: {
      value: (_vm.editStatus.name),
      callback: function($$v) {
        _vm.$set(_vm.editStatus, "name", $$v)
      },
      expression: "editStatus.name"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('ZButton', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.closeStatusEditDialog
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('ZButton', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.saveStatus
    }
  }, [_vm._v("Сохранить")])], 1)], 2), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.editGroupDialog
    },
    on: {
      "update:active": function($event) {
        _vm.editGroupDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.editGroup.id ? 'Изменить' : 'Создать') + " тег")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('ZInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 3,
        max: 255
      }),
      expression: "{required: true, min: 3, max: 255}"
    }],
    attrs: {
      "label": "Название",
      "name": "tag-name",
      "data-vv-as": " ",
      "data-vv-name": "tag-name",
      "data-vv-scope": "tag",
      "error": _vm.errors.first('tag.tag-name')
    },
    model: {
      value: (_vm.editGroup.name),
      callback: function($$v) {
        _vm.$set(_vm.editGroup, "name", $$v)
      },
      expression: "editGroup.name"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('ZButton', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.closeGroupDialog
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('ZButton', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.saveGroup
    }
  }, [_vm._v("Сохранить")])], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33386a43","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tasks/menus/MainMenu.vue
// module id = 1105
// module chunks = 0